import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import {
  isModelConceptClass,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';

export const hasIri = (iri: string, diagram: Diagram): boolean => {
  // check attributes
  if (diagram.model.modelData.attributesByIri[iri]) {
    return true;
  }
  // check classes
  const hasModelConceptClass = diagram.model.nodeDataArray.find(
    (node) => isModelConceptClass(node) && node.value === iri
  );
  if (hasModelConceptClass) {
    return true;
  }
  // check relationships
  const hasModelConceptRelationship = diagram.model.linkDataArray.find(
    (link) => isModelConceptRelationship(link) && link.value === iri
  );
  if (hasModelConceptRelationship) {
    return true;
  }

  return false;
};
